// CX Environment Types
export var Environments;
(function (Environments) {
    Environments["Production"] = "production";
    Environments["Staging"] = "staging";
    Environments["Development"] = "development";
})(Environments || (Environments = {}));
//# sourceMappingURL=types.js.map